import { Component } from 'react';

class CheckboxesWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = { checkboxes: {} };
    this.selectedTaskIds = this.selectedTaskIds.bind(this);
    this.handleCheckboxClick = this.handleCheckboxClick.bind(this);
    this.handleSelectAll = this.handleSelectAll.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.tasks !== prevProps.tasks) {
      this.setState({ checkboxes: {} });
    }
  }

  get checkedCount() {
    const { checkboxes } = this.state;
    return Object.values(checkboxes).filter(checkbox => checkbox).length;
  }

  selectedTaskIds() {
    const { checkboxes } = this.state;
    const taskIds = [];
    Object.keys(checkboxes).forEach(taskId => {
      if (checkboxes[taskId]) {
        taskIds.push(taskId);
      }
    });
    return taskIds;
  }

  areAllChecked() {
    const { tasks } = this.props;
    return tasks.length !== 0 && this.checkedCount === tasks.length;
  }

  handleSelectAll() {
    if (this.areAllChecked()) {
      return this.setState({ checkboxes: {} });
    }
    const { tasks } = this.props;
    const checkboxes = {};
    tasks.forEach(({ id }) => (checkboxes[id] = true));
    return this.setState({ checkboxes });
  }

  handleCheckboxClick = (e, id) => {
    e.preventDefault();
    const { checkboxes: prevCheckboxes } = this.state;
    const checkboxes = { ...prevCheckboxes, [id]: !prevCheckboxes[id] };
    if (checkboxes[id] && e.shiftKey) {
      const { tasks } = this.props;
      let index = tasks.findIndex(task => task.id === id);
      while (index > 0 && !checkboxes[tasks[--index].id]) {
        checkboxes[tasks[index].id] = true;
      }
    }
    this.setState({ checkboxes });
  };

  render = () => {
    const { children } = this.props;
    const { checkboxes } = this.state;
    const areAllChecked = this.areAllChecked();
    return children({
      checkedCount: this.checkedCount,
      selectedTaskIds: this.selectedTaskIds,
      handleCheckboxClick: this.handleCheckboxClick,
      checkboxes,
      handleSelectAll: this.handleSelectAll,
      areAllChecked,
    });
  };
}

export default CheckboxesWrapper;



// WEBPACK FOOTER //
// ./src/component/TasksManagerList/CheckboxesWrapper.js